import { ProductJsonLd, ProductJsonLdProps } from "next-seo"

import { formatReviews } from "@secureo/common/components/StructuredData/ProductStructuredData"

import { Product, Review } from "@secureo/common/typings/Product"
import { NEXT_PUBLIC_HOST } from "utils/envVariables"

const ProductStructuredData = ({ product, reviews, locale, singleGrossPriceCents }: Props) => {
	const { name, sku, slug, variants, shortDescription = "", reviewRatingStatistics } = product

	const masterVariant = variants?.[0]
	const { attributes, images = [] } = masterVariant

	const url = `${NEXT_PUBLIC_HOST}/${locale}/p/${slug}`

	const brand = attributes?.manufacturer ?? null

	const { averageRating: ratingValue, count: reviewCount } = reviewRatingStatistics

	const formattedReviews = formatReviews(reviews)

	const props: Pick<ProductJsonLdProps, "aggregateRating" | "reviews" | "description"> = {}

	if (ratingValue > 0) {
		props.reviews = formattedReviews
		props.aggregateRating = {
			ratingValue: String(ratingValue),
			reviewCount: String(reviewCount),
		}
	}

	const descriptionContainsHTML =
		shortDescription?.includes("<") || shortDescription?.includes("/>")
	if (!descriptionContainsHTML) props.description = shortDescription

	return (
		<ProductJsonLd
			sku={sku}
			productName={name}
			images={images}
			brand={brand}
			offers={{
				price: String(singleGrossPriceCents / 100),
				priceCurrency: "EUR",
				itemCondition: "http://schema.org/NewCondition",
				availability: "http://schema.org/InStock",
				seller: {
					name: "SafeHero",
				},
				url,
			}}
			{...props}
		/>
	)
}

interface Props {
	product: Product
	reviews: Review[]
	locale: string
	singleGrossPriceCents: number
}

export default ProductStructuredData
